import React from 'react';
import SproutsAIBadgeV2 from '../SproutsAIBadgeV2';
import { colors } from 'src/sass/common/_variables';

type Props = {
  role: string;
  description: string;
};

function MillerHeimanRole({ role, description }: Props) {
  return (
    <div className="icp-fitmentment-tooltip-wrapper">
      <div className="icp-fitment-section">
        <div className="icp-fitment-static-heading">
          <p className="icp-fitment-heading">Miller Heiman Role</p>
          <SproutsAIBadgeV2 type="secondary" size="default" />
        </div>
      </div>
      <div className="icp-fitment-section">
        <h5 style={{ color: colors.$colorBlack }}>{role}</h5>
        <div className="icp-fitement-heading">
          <p>{description || ''}</p>
        </div>
      </div>
    </div>
  );
}

export default MillerHeimanRole;
